import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExhaustHead = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 40,
	viewBox: "0 0 50.0 40.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 50.0 0.0 L 50.0 20.0 L 25.0 40.0 L 0.0 20.0 Z M 0.0 20.0 L 50.0 20.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgExhaustHead;
